import { createPayment } from "@/api/store";
import Cookies from "js-cookie";
import StorageKey from "@/utils/storage-key";

const typeNames = {
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  CHECK_OUT: "CHECK_OUT",
  ADD_PAYMENT_INFO: "ADD_PAYMENT_INFO"
};

const getItemsFromCookie = () => {
  const items = Cookies.get(StorageKey.STORE_CART);
  if (items) {
    return JSON.parse(items);
  }
  return [];
};

const state = {
  items: getItemsFromCookie(),
  paymentInfo: {}
};

const mutations = {
  [typeNames.ADD_TO_CART]: (state, item) => {
    const items = state.items;
    const newItems = [...items, item];
    Cookies.set(StorageKey.STORE_CART, JSON.stringify(newItems));
    state.items = newItems;
  },
  [typeNames.REMOVE_FROM_CART]: (state, index) => {
    const items = state.items;
    items.splice(index, 1);
    Cookies.set(StorageKey.STORE_CART, JSON.stringify(items));
    state.items = items;
  },
  [typeNames.CHECK_OUT]: state => {
    Cookies.remove(StorageKey.STORE_CART);
    state.items = [];
    state.paymentInfo = {};
  },
  [typeNames.ADD_PAYMENT_INFO]: (state, info) => {
    state.paymentInfo = info;
  }
};

const actions = {
  setPaymentInfo({ commit }, info) {
    commit(typeNames.ADD_PAYMENT_INFO, info);
  },
  addToCart({ commit }, item) {
    commit(typeNames.ADD_TO_CART, item);
  },
  removeFromCart({ commit }, index) {
    commit(typeNames.REMOVE_FROM_CART, index);
  },
  checkoutCart({ commit }, data) {
    return new Promise((resolve, reject) => {
      createPayment(data)
        .then(res => {
          const info = {
            recipient_phone_number: data.phoneVal,
            recipient_name: data.recipient_name
          };
          console.log(info, data);
          commit(typeNames.CHECK_OUT);
          resolve({ res, info });
        })
        .catch(err => {
          reject(err);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};
